export class NotificationFilter {
    title: string;
    date: string;
    toNotificationDate: string;
    status: string = "";    
}